import { OHLCV, TimeOfDay } from '../../models/market-data/types';

export const DEFAULT_NEWS_PAGE_SIZE = 5;
export const DEFAULT_NEWS_PAGE_NUMBER = 1;
export const MAX_SYMBOLS_PER_REQUEST_LIMIT = 15;
export const DEFAULT_MARKET_TIME: TimeOfDay = { hour: 0, minute: 0 };
export const DEFAULT_OHLCV_DATA: OHLCV = { symbol: '', high: 0, low: 0, open: 0, close: 0, volume: 0, date: '', time: '' };

export const WEEK_INTERVAL_MINUTES = 15;
export const MONTH_INTERVAL_MINUTES = 60;
export const YEAR_INTERVAL_DAYS = 7; // 1 week = 7 days
export const MONTH_BUCKET_MINUTES_BEFORE_OPEN = 30;

export const MONDAY_DAY_INDEX = 1;
export const SUNDAY_DAY_INDEX = 0;
export const DAYS_FROM_SUNDAY_TO_PREVIOUS_MONDAY = 6;
export const DAYS_FROM_SUNDAY_TO_NEXT_MONDAY = 1;
export const WEEK_OFFSET_FOR_NEXT_MONDAY = 8;

export const FIRST_DAY_OF_MONTH = 1;

export const BUCKET_LOOKBACK_CONFIG = {
  WEEK: {
    AFTER_OPEN: 6,
    BEFORE_OPEN: 7,
  },
  MONTH_OFFSET: 3,
  THREE_MONTHS: {
    LOOKBACK_MONTHS: 3,
  },
  ONE_YEAR: {
    LOOKBACK_YEARS: 1,
  },
  FIVE_YEARS: {
    LOOKBACK_YEARS: 5,
  },
} as const;
